<template>
  <div>
    <div class="tw-flex tw-items-start tw-space-x-8">
      <div class="tw-w-120 tw-border tw-border-light-4 tw-rounded-xs tw-p-6">

        <div class="tw-space-y-2">
          <div class="tw-flex tw-items-center tw-justify-between">
            <div class="tw-font-semibold">Filter Suburb:</div>
            <button class="tw-text-blue tw-px-2" v-on:click="form.suburb = null">clear</button>
          </div>
          <div class="tw-border tw-border-light-4 tw-rounded">
            <v-multi-select
              :options="suburbs"
              label="name"
              :showLabels="false"
              v-model="form.suburb"
            />
          </div>
        </div>
        <div class="tw-space-y-2 tw-mt-8">
          <div class="tw-flex tw-items-center tw-justify-between">
            <div class="tw-font-semibold">Filter Category:</div>
            <button class="tw-text-blue tw-px-2" v-on:click="form.category = null">clear</button>
          </div>
          <div class="tw-border tw-border-light-4 tw-rounded">
            <v-multi-select
              :options="categories"
              label="title"
              :showLabels="false"
              v-model="form.category"
            />
          </div>
        </div>
        <button class="tw-rounded tw-bg-secondary tw-text-light tw-font-bold tw-w-full tw-text-center tw-px-6 tw-py-4 tw-text-2xl tw-mt-8" v-on:click="(form.page = 1) && request()">Apply</button>
      </div>
      <div class="tw-flex-1">
        <div class="tw-rounded-xs tw-bg-light tw-border tw-border-light-4 tw-px-5 tw-mb-6 tw-flex tw-items-center">
          <div class="tw-font-bold tw-opacity-50">Sort By :</div>
          <template v-for="item in [{value : 'discount',label : 'Highest Discount'},{value : '-discount',label : 'Lowest Discount'}]">
            <button class="tw-px-4 tw-py-1 tw-ml-5 tw-px-4 tw-font-semibold tw-py-4 tw-outline-none tw-border-b-2"
              :class="{'tw-border-b-2 tw-border-red tw-text-red' : form.sort === item.value,'tw-border-light' : form.sort !== item.value}"
              v-on:click="(form.sort = item.value) && request()"
            >{{item.label}}
            </button>
          </template>
        </div>
        <div class="tw-relative">
          <div v-if="loading" class="tw-absolute tw-left-0 tw-w-full tw-top-0 tw-h-full tw-bg-light tw-bg-opacity-90 tw-z-10 tw-flex flex-center">
            <i class="bx bx-loader bx-spin tw-text-6xl"></i>
          </div>
          <div class="tw-grid tw-grid-cols-4 tw-flex-1 tw-gap-8">
            <v-promotion-item v-for="item in items" :key="item.id" :item="item"></v-promotion-item>
          </div>
          <div class="tw-flex tw-items-center tw-space-x-2 tw-mt-6">
            <button v-on:click="(form.page = page) && request()" v-for="page in _.range(1,pagination.last_page + 1)"
              class="tw-p-3 tw-font-semibold cursor:tw-bg-light-2 cursor:tw-text-blue tw-rounded-sm tw-min-w-16 tw-min-h-16 tw-flex flex-center"
              :class="{'tw-bg-light-2 tw-text-blue': page === pagination.current_page}"
            >
              {{page}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    props: {
      suburbs: {},
      categories: {},
    },
    data: v => ({
      items: {},
      form: {
        suburb: null,
        category: null,
        sort: 'discount',
        page: 1,
      },
      pagination: {},
      loading: false,
    }),
    created() {
      this.request()
    },
    methods: {
      request() {
        this.loading = true
        axios.get('/api/v1/promotion', {
          params: {
            ...(this.form.category !== null ? {category_id: this.form.category.id} : {}),
            ...(this.form.suburb !== null ? {suburb_id: this.form.suburb.id} : {}),
            ...(this.form.sort !== null ? {sort: this.form.sort} : {}),
            page: this.form.page,
          }
        })
          .then(resp => {
            this.items = resp.data.data
            this.pagination = {
              current_page: resp.data.current_page,
              total: resp.data.total,
              last_page: resp.data.last_page,
            }
          })
          .finally(() => this.loading = false)
      }
    },
  }
</script>
